import {Fragment} from "../index";
import DceHTMLElement from "dce-engine/lib/types/DceHTMLElement";
import DceWireEventDetails from "./dceplugin/DceWireEventDetails";
import wireActionParse from "./utils/wireActionParse";

export default class FragmentWireEventListener {

    private element: DceHTMLElement;
    private fragment: Fragment;

    private debounces: Map<string, any> = new Map<string, any>();

    constructor(element: DceHTMLElement, fragment: Fragment) {
        this.element = element;
        this.fragment = fragment;

        this.element.addEventListener('dceWire', async (e: CustomEvent<DceWireEventDetails>) => {
            e.stopPropagation();
            let details = e.detail;

            if(details.type == 'change' || details.type == 'input') {

                if (this.debounces.has(details.type)) {
                    clearTimeout(this.debounces.get(details.type));
                    this.debounces.delete(details.type);
                }

                let timeoutId = setTimeout(
                    async () => {
                        console.log("EXEC DEBOUNCED");
                        try {
                            let parsed = wireActionParse(details.type, details.attr);
                            parsed.formData = e.detail.formData;

                            if (e.detail.element) {
                                if (e.detail.element.hasAttribute('data-raw-get')) {
                                    parsed.rawGet = e.detail.element.getAttribute('data-raw-get');
                                }
                            }

                            await fragment.executeWireEvent(
                                details.type,
                                parsed,
                                details.element
                            );

                        } catch (error) {
                            console.error(error);
                        } finally {
                            this.debounces.delete(details.type);
                        }
                    },
                    200
                );

                this.debounces.set(details.type, timeoutId);

                return;
            }

            try {
                let parsed = wireActionParse(details.type, details.attr);
                parsed.formData = e.detail.formData;

                if(details.type == 'submit'){
                    console.log("SUBMIT", e,  e.detail.originalEvent instanceof SubmitEvent);

                    if(e.detail.originalEvent && e.detail.originalEvent instanceof SubmitEvent){
                        let submitEvent = (e.detail.originalEvent as SubmitEvent);

                        if(submitEvent.submitter){

                            let submitterName = submitEvent.submitter.getAttribute('name');
                            let submitterValue = submitEvent.submitter.getAttribute('value');

                            if(submitterName){
                                if(!parsed.formData){
                                    parsed.formData = new FormData();
                                }
                                parsed.formData.set(submitterName, submitterValue);

                                console.log("SUBMIT", parsed);
                            }
                        }
                    }
                }


                if (e.detail.element) {

                    if (e.detail.element.hasAttribute('data-raw-get')) {
                        parsed.rawGet = e.detail.element.getAttribute('data-raw-get');
                    }

                }

                await fragment.executeWireEvent(
                    details.type,
                    parsed,
                    details.element
                );

            } catch (error) {
                console.error(error);
            } finally {
                this.debounces.delete(details.type);
            }

        });

    }




}